// SearchBySubject.jsx (updated)
import { useState } from "react";
import "./search.css";
import EAIMLogo from "../img/eaim_logo_w.png";

function pad2(n) {
  return String(n).padStart(2, "0");
}
function fmtLocal(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  const h = d.getHours() % 12 || 12;
  const m = pad2(d.getMinutes());
  const am = d.getHours() >= 12 ? "PM" : "AM";
  return `${h}:${m} ${am}`;
}

export default function SearchBySubject() {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [results, setResults] = useState([]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setResults([]);
    if (!q.trim()) return;

    setLoading(true);
    try {
      const r = await fetch(
        `${
          process.env.REACT_APP_API
        }/rooms/schedules?subject=${encodeURIComponent(q)}`,
        {
          headers: { Accept: "application/json" },
          cache: "no-store",
        }
      );
      const json = await r.json();
      if (!r.ok || json.success === false) {
        throw new Error(json?.message || "Request failed");
      }
      setResults(json.data || []);
    } catch (e) {
      setErr(e.message || "Failed to search");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="eaim-wrap">
      <header className="eaim-header">
        <div className="brand">
          <img src={EAIMLogo} alt="EAIM Logo" style={{ height: 80, objectFit: "contain" }} />
        </div>
      </header>

      <main className="container">
          <h2 className="title">Search</h2>

          <form onSubmit={submit} className="form">
            <input
              type="text"
              placeholder="Subject, lecturer, or course…"
              className="input"
              style={{background: "#fff", color: "#000"}}
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
            <button className="btn" type="submit" disabled={loading} style={{background: "#B31E8D",color: "#fff"}}>
              {loading ? "Searching..." : "Search"}
            </button>
          </form>

          {err && <p style={{ color: "#b00020", marginTop: 12 }}>{err}</p>}

          {/* Results */}
          <div style={{ marginTop: 16 }}>
            {loading && <p>Loading…</p>}
            {!loading && results.length === 0 && q.trim() && !err && (
              <p>No results for “{q.trim()}”.</p>
            )}
            {!loading && results.length > 0 && (
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  display: "grid",
                  gap: 12,
                }}
              >
                {results.map((ev, i) => (
                  <li
                    key={i}
                    style={{
                      border: "1px solid #E3E6EA",
                      borderRadius: 10,
                      padding: "10px 12px",
                      background: "#fff",
                    }}
                  >
                    <div style={{ fontWeight: 700 }}>
                      {ev.title || "(No title)"}
                    </div>
                    <div style={{ fontSize: 14, opacity: 0.85 }}>
                      Room: {ev.room}
                    </div>
                    <div style={{ fontSize: 14 }}>
                      {fmtLocal(ev.start)} – {fmtLocal(ev.end)}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
      </main>
    </div>
  );
}
